import { Sparkles } from "lucide-react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { DimensionCard } from "./DimensionCard";
import { MetricCard } from "./MetricCard";
import type { DailyTeamStats } from "../api/useTeamStats";

interface QualitySectionProps {
  daily: DailyTeamStats[];
}

export function QualitySection({ daily }: QualitySectionProps) {
  const totalCompleted = daily.reduce((s, d) => s + d.itemsCompleted, 0);
  const totalRework = daily.reduce((s, d) => s + d.reworkCount, 0);
  const totalEscalations = daily.reduce((s, d) => s + d.escalations, 0);
  const reworkRate = totalCompleted > 0 ? (totalRework / totalCompleted) * 100 : 0;
  const escalationRatio = totalCompleted > 0 ? (totalEscalations / totalCompleted) * 100 : 0;

  const chartData = daily.map((d) => {
    const rate = d.itemsCompleted > 0 ? (d.reworkCount / d.itemsCompleted) * 100 : 0;
    return {
      date: new Date(d.date + "T00:00:00").toLocaleDateString("en-US", { month: "short", day: "numeric" }),
      reworkRate: Math.round(rate * 10) / 10,
    };
  });

  return (
    <DimensionCard title="Quality" icon={Sparkles} colorTheme="blue" id="quality">
      <div className="grid grid-cols-2 gap-3 mb-4">
        <MetricCard label="Rework Rate" value={`${Math.round(reworkRate * 10) / 10}%`} />
        <MetricCard label="Escalation Ratio" value={`${Math.round(escalationRatio * 10) / 10}%`} />
      </div>
      {chartData.length > 0 ? (
        <div className="h-48">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={chartData} margin={{ top: 8, right: 8, left: -20, bottom: 0 }}>
              <XAxis dataKey="date" tick={{ fontSize: 11, fill: "#9ca3af" }} axisLine={false} tickLine={false} />
              <YAxis tick={{ fontSize: 11, fill: "#9ca3af" }} axisLine={false} tickLine={false} unit="%" />
              <Tooltip contentStyle={{ backgroundColor: "#1f2937", border: "none", borderRadius: "6px", color: "#f9fafb", fontSize: "12px" }} />
              <Line type="monotone" dataKey="reworkRate" stroke="#2563eb" strokeWidth={2} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <div className="flex items-center justify-center h-48 bg-gray-50 dark:bg-white/5 rounded-lg">
          <p className="text-sm text-gray-400">No trend data available</p>
        </div>
      )}
    </DimensionCard>
  );
}
